import React, { ReactNode } from 'react'
import { styles } from './styles'

interface StatProps {
  isDisabled?: boolean
  name: string
  value: number | ReactNode
  link?: string
  testId: string
  onClick?: () => void
  displayAsLink?: boolean
}

export const Stat = ({
  isDisabled = false,
  name,
  value,
  link,
  testId,
  displayAsLink = false,
  onClick
}: StatProps) => {
  return (
    <div className={styles.Stat(isDisabled)} data-testid={testId}>
      {link && !isDisabled ? (
        <a href={link} className={styles.StatLink(true)}>
          {value}
        </a>
      ) : (
        <div className={styles.StatLink(displayAsLink)} onClick={onClick}>
          {value}
        </div>
      )}
      <div className={styles.StatInfo}>
        <div>{name}</div>
      </div>
    </div>
  )
}
